import { http } from '@/http/axios.js'
import axios from 'axios'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { showScreenLoading, hideScreenLoading } from '@/http/loading.js'
import { Message } from 'element-ui'
import { dateFormat } from '@/utils/index.js'
// 列表
export function getListAPI(params) {
  return http({
    url: '/admin/capital/page',
    method: 'get',
    params
  })
}
// 状态
export function changeStatusAPI(data) {
  return http({
    url: '/admin/capital/status/edit',
    method: 'post',
    data
  })
}
// 线下充值
export function rechargeAPI(data) {
  return http({
    url: '/admin/capital/recharge',
    method: 'post',
    data
  })
}
// 删除
export function delAPI(id) {
  return http({
    url: '/admin/merchant/delete',
    method: 'post',
    data: { id }
  })
}
// 新增
export function addAPI(data) {
  return http({
    url: '/admin/capital/add',
    method: 'post',
    data
  })
}
// 编辑
export function editAPI(data) {
  return http({
    url: '/admin/capital/edit',
    method: 'post',
    data
  })
}
// 详情
export function getDetailAPI(id) {
  return http({
    url: '/admin/capital/detail',
    method: 'get',
    params: { id }
  })
}

// 全部导出
export function DownloadAPI(data) {
  showScreenLoading()
  axios({
    method: 'post',
    url: '/api/admin/capital/export',
    responseType: 'blob',
    data,
    headers: {
      Authorization: getToken() || ''
    }
  })
    .then(async res => {
      hideScreenLoading();
      let data = res.data;
      let url = window.URL.createObjectURL(new Blob([data]));
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      let filename = `果冻租资方列表${dateFormat()}.xlsx`;
      a.setAttribute('download', decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click(); //执行下载
      window.URL.revokeObjectURL(a.href); //释放url
      document.body.removeChild(a); //释放标签
    })
    .catch(error => {
      hideScreenLoading();
      console.log(error);
    })
}
